<template>
  <div class="combination-outcome__container">
    <div class="combination-outcome__content">
      <div
        class="combination-outcome__item"
        :class="{ disable: outcome.pick > maxPick }"
        v-for="(outcome, index) in combinationOutcome"
        :key="index"
        @click="handleSelectOutcome(outcome)"
      >
        <div class="item__infor">
          <span
            class="item__infor--icon"
            :class="{
              selected: outcomeSelected && outcomeSelected.id == outcome.id,
            }"
          >
            <i class="bi bi-check-circle-fill"></i>
          </span>
          <p class="item__infor--name">{{ outcome.name }}</p>
          <p>{{ formatPrice(outcome.odds) }}</p>
        </div>
        <InputAmount
          @amount-value="handleReceiveAmount"
          :itemId="outcome.id"
          :amountDefault="outcome.amount"
          :settings="outcome"
          :odds="+outcome.odds"
        />
      </div>
    </div>
    <div class="combination-outcome__action">
      <ButtonCommon text="back" class="button__primary" @action="handleBack" />
      <ButtonCommon
        text="add"
        class="button__primary"
        @action="handleAdd"
        :isDisable="!outcomeSelected"
      />
    </div>
  </div>
</template>
<script>
import utilsMixin from "@/mixins/function-utils";
import ButtonCommon from "@/components/common/button";
import InputAmount from "@/components/common/input/input-amount.vue";

export default {
  mixins: [utilsMixin],
  components: { ButtonCommon, InputAmount },
  props: {
    combinationOutcome: {
      type: Array,
    },
    maxPick: Number,
  },
  data() {
    return {
      outcomeSelected: null,
    };
  },
  methods: {
    handleBack() {
      this.$emit("back");
    },
    handleAdd() {
      this.$emit("add", this.outcomeSelected);
    },
    handleSelectOutcome(outcome) {
      this.outcomeSelected = outcome;
    },
    handleReceiveAmount(data) {
      const outcome = this.combinationOutcome?.find(
        (o) => o.id == data.itemId
      );
      if (outcome) {
        outcome.amount = data.amount;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/public/scss/components/coupons/combination-outcome.scss";
</style>

